import { Router } from '@angular/router';
import { NewPaymentRequest, PaymentList, PaymentOpenerUser, PaymentRightsProperties, PaymentSearch } from '../Models/PaymentProperties';
import { PaymentService } from '../Services/payment.service';
import { Component } from '@angular/core';
import { ActiveDepositType, ActiveModeOfPayment, ManagerListForPayments } from '../Models/ActiveClasses';
@Component({
  selector: 'app-manager-payment-list',
  templateUrl: './manager-payment-list.component.html',
  styleUrls: ['./manager-payment-list.component.css']
})
/** ManagerPaymentList component*/
export class ManagerPaymentListComponent {
  paymentList: PaymentList[];
  modeOfPayments: ActiveModeOfPayment[] = [];
  modeOfPaymentsForAdd: ActiveModeOfPayment[] = [];
  managerList: ManagerListForPayments[] = [];
  paymentRequest = new NewPaymentRequest();
  rightsObj = new PaymentRightsProperties();
  primeShowModalSuccessModel:boolean =false;
  setIntervalSetting:any;
  paymentSearch = new PaymentSearch();
  depositTypesList: ActiveDepositType[] | undefined;
  currentDate: any;
  startDate: any;
  paymentStatusList: object[] = [];
  loaderVar:boolean=false;
  constructor(private service: PaymentService, private router: Router) {
  }
  ngOnInit(): void {

    try {
      this.paymentStatusList = [{ paymentStatus: "All" },{ paymentStatus: "Requested" }, { paymentStatus: "Approved" }, { paymentStatus: "Rejected" }]
      this.GetCurrentDate();
      this.CheckPaymentRights();
      this.LoadPaymentList();
      this.setIntervalSetting = setInterval(() => {
        this.LoadPaymentList();
      }, 120000);
      this.LoadBaseData();

    } catch (ex) { }
  }
  ngOnDestroy():void{
    if(this.setIntervalSetting){
      clearInterval(this.setIntervalSetting);
    }
  }
  private LoadBaseData = (): void => {
    try {
      this.service.getPaymentBaseData(localStorage.getItem("AgencyId")).subscribe((data) => {
        this.depositTypesList = data.depositTypes;
        this.modeOfPaymentsForAdd=data.modeOfPayments;
        this.modeOfPaymentsForAdd=JSON.parse(JSON.stringify(this.modeOfPaymentsForAdd));
        this.modeOfPayments = data.modeOfPayments;
        this.managerList = data.managerList;
        let activeDeposits:ActiveDepositType= new ActiveDepositType();
        activeDeposits.depositTypeId=0;
        activeDeposits.depositTypeName="All";
        this.depositTypesList.unshift(activeDeposits);
        let mop:ActiveModeOfPayment= new ActiveModeOfPayment();
        mop.modeOfPaymentId=0;
        mop.modeOfPaymentName="All";
        this.modeOfPayments.splice(0,0,mop);
      });
    } catch (ex) {
      ////Console.log(ex);
    }
  }
  private GetCurrentDate = (): void => {
    let date = new Date();
    let todayDate: any = date.getDate();
    let month: any = date.getMonth() + 1;
    let year = date.getFullYear();
    if (todayDate < 10) {
      todayDate = "0" + todayDate;
    }
    if (month < 10) {
      month = "0" + month;
    }
    this.currentDate = year + "-" + month + "-" + todayDate;
    let startOfMonthDate = new Date(new Date().setDate(date.getDate() - 30));
    let startDate: any = startOfMonthDate.getDate();
    let startMonth: any = startOfMonthDate.getMonth() + 1;
    let startYear: any = startOfMonthDate.getFullYear();
    if (startDate < 10) {
      startDate = "0" + startDate;
    }
    if (startMonth < 10) {
      startMonth = "0" + startMonth;
    }
    this.startDate = startYear + "-" + startMonth + "-" + startDate;
    // console.log(this.startDate)
  }
  public SetRequestDateFrom = (date: any): void => {
    if (date.target.value == "") {
      this.paymentSearch.requestDateFrom = this.startDate;
    }
    else if (new Date(date.target.value) > new Date(this.currentDate)) {
      date.target.value = this.startDate;
      this.paymentSearch.requestDateFrom = this.startDate;
    }
    else {
      this.paymentSearch.requestDateFrom = date.target.value;
    }

  }
  public SetRequestDateTo = (date: any): void => {
    if (date.target.value == "") {
      this.paymentSearch.requestDateTo = undefined;
    }
    else if (new Date(date.target.value) > new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.paymentSearch.requestDateTo = this.currentDate;
    }
    else {
      this.paymentSearch.requestDateTo = date.target.value;
    }
  }
  private LoadPaymentList = (): void => {
    try {
      this.paymentSearch.agencyId = localStorage.getItem('AgencyId');
      this.paymentSearch.userId = Number(localStorage.getItem('UserId'));
      this.paymentSearch.paymentStatus = null;
      this.paymentSearch.requestDateFrom = this.startDate;
      this.paymentSearch.requestDateTo = this.currentDate;
      this.paymentSearch.modeOfPayment = 0;
      this.paymentSearch.depositType = 0;
      this.paymentSearch.managerId = 0;
      //this.service.getManagerPaymentList(this.paymentSearch).subscribe((data) => {
      //  this.paymentList = data;
      //});
      this.service.getManagerByAgecnyPaymentList(this.paymentSearch.userId, this.paymentSearch.agencyId).subscribe((data) => {
        this.paymentList = data;
      });
    } catch (ex) {
      ////Console.log(ex);
    }
  }
  private CheckPaymentRights = (): void => {
    this.service.CheckPaymentRights(localStorage.getItem('AgencyId'), localStorage.getItem('UserId')).subscribe((data) => {
      this.rightsObj = data;
    });
  }
  public ManagePayments = (payment: any): void => {
    if (payment.status == "Requested") {
      this.service.InprogressPayment(payment.paymentId).subscribe((data) => {
        if (data.inProcess == false) {
          let paynew = new PaymentOpenerUser();
          paynew.paymentId = payment.paymentId;
          paynew.openerUser = Number(localStorage.getItem("UserId"));
          this.service.PaymentGatewayPersonDetection(paynew).subscribe(() => {
            this.paymentRequest.paymentTypeId = payment.paymentId;
            this.paymentRequest.paymentModeTypeId = 0;
            this.paymentRequest.newPaymentRequest = true;
            this.paymentRequest.paymentOpenFrom="managerList";
            this.service.SetRequestData(this.paymentRequest);
            this.router.navigateByUrl('/paymentAddEdit');
          })
        }
        else if (data.inProcess == true) {
          this.primeShowModalSuccessModel=true;
        }
      })
     }
    else {
      this.paymentRequest.paymentTypeId = payment.paymentId;
      this.paymentRequest.paymentModeTypeId = 0;
      this.paymentRequest.newPaymentRequest = true;
      this.paymentRequest.paymentOpenFrom="managerList";
      this.service.SetRequestData(this.paymentRequest);
      this.router.navigateByUrl('/paymentAddEdit');
    }
  }
  public ClosePaymentSuccessModel = (): void => {
    this.primeShowModalSuccessModel = false;
  }
  public AddNewPayment = (paymentId: number): void => {
    if (this.rightsObj.addPayment) {
      this.paymentRequest.paymentModeTypeId = paymentId;
      this.paymentRequest.paymentTypeId = 0;
      this.paymentRequest.newPaymentRequest = true;
      this.paymentRequest.paymentOpenFrom="";
      this.service.SetRequestData(this.paymentRequest);
      this.router.navigateByUrl('/paymentAddEdit');
    }
    else {
      const paymenthead = document.getElementById("paymentHeadings");
      paymenthead.style.color = "red";
      paymenthead.innerHTML = "You Don't Have Rights!";
      setTimeout(() => {
        paymenthead.style.color = "var(--first-color-second)";
        paymenthead.innerHTML = "Manager's Payment List";
      }, 5000);
    }
  }
  public SubmitPaymentSearchForm = (paymentSearchForm:any): void => {
    this.loaderVar=true;
    this.paymentSearch.agencyId = localStorage.getItem('AgencyId');
    this.paymentSearch.userId = Number(localStorage.getItem('UserId'));;
    if(this.paymentSearch.modeOfPayment==null || this.paymentSearch.modeOfPayment==undefined){
      this.paymentSearch.modeOfPayment=0;
    }
    if(this.paymentSearch.depositType==null || this.paymentSearch.modeOfPayment==undefined){
      this.paymentSearch.depositType=0;
    }
    if (this.paymentSearch.managerId == null || this.paymentSearch.managerId == undefined) {
      this.paymentSearch.managerId = 0;
    }
    this.service.getManagerPaymentList(this.paymentSearch).subscribe((data) => {
      this.loaderVar=false;
      this.paymentList = data;
    });
  }





  //   /** ManagerPaymentList ctor */
  // paymentList: PaymentList[];
  // userId: number = 0;
  // agencyId: string = "";
  // @ViewChild('warningPayment', { static: false }) warningPayment: ElementRef | undefined;
  // constructor(private service: PaymentService, private router: Router, private activeModal: NgbModal) {
  //   this.onClickEditPayment = this.onClickEditPayment.bind(this);
  //   //this.onClickEditSupplierVisa = this.onClickEditSupplierVisa.bind(this);
  // }


  // ngOnInit() {

  //   try {
  //     this.loadPaymentList();

  //   } catch (ex) {  }
  // }
  // loadPaymentList() {
  //   try {
  //     //localStorage.setItem('UserId', '2');
  //     //localStorage.setItem('AgencyId', 'AG02');
  //     this.userId = Number(localStorage.getItem('UserId'));
  //     this.agencyId = localStorage.getItem('AgencyId');
  //     this.service.getManagerPaymentList(this.userId, this.agencyId).subscribe((data) => {
  //       //console.log(data);
  //       this.paymentList = (data);

  //     });
  //   } catch (ex) {  }
  // }

  // onClickEditPayment(e) {

  //   //localStorage.setItem("ActionType", "AirOfficeEdit");
  //   //localStorage.setItem("UserId", "1")
  //   if (e.row.data.status == "Requested") {
  //     this.service.InprogressPayment(e.row.data.paymentId).subscribe((data) => {
  //       if (data.inProcess == false) {
  //         let paynew = new PaymentOpenerUser();
  //         paynew.paymentId = e.row.data.paymentId;
  //         paynew.openerUser = Number(localStorage.getItem("UserId"));

  //         this.service.PaymentGatewayPersonDetection(paynew).subscribe((data) => {
  //           //console.log(e);

  //           localStorage.setItem("paymentId", e.row.data.paymentId);
  //           localStorage.setItem('fromRoute', 'managerList');
  //           //console.log(e.row.data.paymentId);
  //           this.router.navigateByUrl('/paymentAddEdit');
  //         })
  //       }
  //       else if (data.inProcess == true) {
  //         this.activeModal.open(this.warningPayment, {
  //           centered: true,
  //           size: 'md'
  //         })
  //       }
  //     })
  //   }
  //   else {
  //     localStorage.setItem("paymentId", e.row.data.paymentId);
  //     localStorage.setItem('fromRoute', 'managerList');
  //     //console.log(e.row.data.paymentId);
  //     this.router.navigateByUrl('/paymentAddEdit');
  //   }


    // }
    // AddNewPayment() {
    //   //localStorage.setItem("UserId", "1")
    //   //localStorage.setItem("ActionType", "AirSupplierAdd");
    //   localStorage.removeItem('paymentId');
    //   localStorage.setItem('fromRoute','managerList');
    //   this.router.navigateByUrl('/paymentAddEdit');
    // }
  }
